import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  search: yup.string(),
});

export const formConfig = {
  resolver: yupResolver(schema) as Resolver<ISearch>,
  mode: "all" as keyof ValidationMode,
  defaultValues: { search: "" },
};
